<template>
    <div class="user member-notification-detail-page camp-member-page">
        <div class="headerbg">
            <b-container class="d-flex align-items-center justify-content-between">
                <h1>通知內容</h1>
                <b-button variant="outline-secondary" size="sm" @click="logout">登出</b-button>
            </b-container>
        </div>
        <b-container fluid="xl">
            <b-row>
                <b-col cols="12" md="2" class="member-sidebar-col"><nacUser /></b-col>
                <b-col cols="12" md="10" class="member-content-col">
                    <b-card v-if="notification" class="mb-3">
                        <div class="notification-sticky-header">
                            <div class="mb-3">
                                <b-button variant="outline-secondary" @click="_go('/memberNotification')">
                                    <b-icon icon="chevron-left" /> 通知中心
                                </b-button>
                            </div>
                            <div class="d-flex flex-wrap align-items-center mb-2">
                                <b-badge variant="info" class="mr-2">{{ typeText(notification.Type) }}</b-badge>
                                <time class="small text-muted">{{ formatDate(notification.PublishedAt) }}</time>
                            </div>
                            <h2 class="notification-title mb-0">{{ notification.Title }}</h2>
                        </div>
                        <div class="notification-html" v-html="safeContent"></div>
                        <div v-if="notification.Update" class="small text-muted mt-3">最後更新：{{ formatDate(notification.Update) }}</div>
                    </b-card>
                    <b-card v-if="notification && notification.Attachments && notification.Attachments.length" class="mb-3">
                        <template #header>
                            <span class="font-weight-bold">
                                <b-icon icon="paperclip" class="mr-1"></b-icon>
                                附件 <b-badge pill variant="secondary" class="ml-1">{{ notification.Attachments.length }}</b-badge>
                            </span>
                        </template>
                        <b-list-group>
                            <b-list-group-item v-for="file in notification.Attachments" :key="file.Id" class="d-flex justify-content-between align-items-center">
                                <span class="text-truncate mr-2">{{ file.Title }}</span>
                                <b-button size="sm" variant="outline-primary" @click="download(file)">下載</b-button>
                            </b-list-group-item>
                        </b-list-group>
                    </b-card>
                    <div v-else-if="loading" class="text-center text-muted py-5">載入中...</div>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import moment from 'moment';
import nacUser from '@/components/nacUser.vue';
import { apiDownloadMemberNotificationAttachment, apiGetMemberNotification } from '@/api/API';
import { memberNotificationTypeText, sanitizeNotificationHtml } from '@/utils/memberNotification';
import memberLoginContinuation from '@/mixins/memberLoginContinuation';

export default {
    name: 'MemberNotificationDetail',
    mixins: [memberLoginContinuation],
    components: { nacUser },
    data() { return { loading: false, notification: null }; },
    computed: {
        safeContent() { return sanitizeNotificationHtml(this.notification?.Content); },
    },
    mounted() {
        if (this.IsNull(this._sessionData('TokenID')) === '') {
            this.requestMemberLogin(this.loadNotification);
            return;
        }
        this.loadNotification();
    },
    methods: {
        async loadNotification() {
        this.loading = true;
        try {
            const response = await apiGetMemberNotification(this.$route.params.id);
            this.notification = response.data;
            await this.$store.dispatch('memberNotification/fetchUnreadCount');
        } catch (error) {
            if (error?.response?.status === 404) {
                alert('找不到通知，或通知已撤回');
                this._go('/memberNotification');
            }
        } finally {
            this.loading = false;
        }
        },
        typeText: memberNotificationTypeText,
        formatDate(value) { return value ? moment(value).format('YYYY/MM/DD HH:mm') : '-'; },
        async download(file) {
            const response = await apiDownloadMemberNotificationAttachment(file.Id);
            const url = window.URL.createObjectURL(response.data);
            const link = document.createElement('a');
            link.href = url;
            link.download = file.Title || '附件';
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        },
        logout() {
            this._sessionData('NewToken', '');
            this._sessionData('TokenID', '');
            this._go('/');
        },
    },
};
</script>

<style scoped>
.notification-sticky-header { position: sticky; top: 55px; z-index: 5; margin: -1.25rem -1.25rem 1.25rem; border-bottom: 1px solid #dee2e6; padding: 1rem 1.25rem; background: #fff; box-shadow: 0 0.2rem 0.35rem rgba(0, 0, 0, 0.06); }
.notification-title { font-size: 1.5rem; font-weight: 600; overflow-wrap: anywhere; }
.notification-html { line-height: 1.75; overflow-wrap: anywhere; }
.notification-html ::v-deep img { display: block; max-width: 100%; height: auto; margin: 1rem auto; }
.notification-html ::v-deep iframe { display: none; }
.notification-html ::v-deep table { width: 100%; max-width: 100%; border-collapse: collapse; margin: 1rem 0; }
.notification-html ::v-deep th,
.notification-html ::v-deep td { border: 1px solid #dee2e6; padding: 0.5rem 0.75rem; text-align: left; }
.notification-html ::v-deep thead th { background-color: #e9ecef; font-weight: 600; }
.notification-html ::v-deep tbody tr:nth-child(even) td { background-color: #f8f9fa; }

@media (max-width: 529.98px) {
    .notification-sticky-header { padding: 0.75rem 1rem; }
    .notification-sticky-header .btn { padding: 0.25rem 0.5rem; font-size: 0.875rem; }
    .notification-title { font-size: 1.15rem; line-height: 1.4; }
}
</style>
